export default __webpack_public_path__ + "media/countdown-stereo-delay-102242.ae0c3f56.mp3";